import { render, staticRenderFns } from "./CreateSmsTemplate.vue?vue&type=template&id=1b675cf6"
import script from "./CreateSmsTemplate.vue?vue&type=script&lang=js"
export * from "./CreateSmsTemplate.vue?vue&type=script&lang=js"
import style0 from "./CreateSmsTemplate.vue?vue&type=style&index=0&id=1b675cf6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports